import {
  typographyHelper,
  spacingHelper,
  paletteHelper,
  radiusHelper,
  Text,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ContentBrick } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import {
  DynamicText,
  TextWithStyles,
} from '../../../../../app-kit/components/DynamicText/DynamicText';

const Title = styled(Text)`
  ${typographyHelper('subtitle02')};
`;

const DataTile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacingHelper('twoExtraSmall')};
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  border-radius: ${radiusHelper('medium')};
  padding-top: ${spacingHelper('medium')};
  padding-bottom: ${spacingHelper('medium')};
`;

const Value = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${spacingHelper('extraSmall')};
  ${typographyHelper('title02')};
`;

const Unit = styled(Text)`
  ${typographyHelper('subtitle01')};
`;

const Description = styled(DynamicText)`
  ${typographyHelper('caption')};
`;

interface SubBrickProps {
  title: string;
  value: string;
  unit?: string;
  description: TextWithStyles[];
}

export const SubBrick: FunctionComponent<SubBrickProps> = ({ title, value, unit, description }) => {
  return (
    <ContentBrick titleComponent={<Title>{title}</Title>}>
      <DataTile>
        <Value>
          {value}
          {unit && <Unit>{unit}</Unit>}
        </Value>
        <Description
          dynamicTexts={description}
          variant="caption"
          colorVariant="textSecondary"
          variantBold="caption"
          colorVariantBold="textSecondary"
        />
      </DataTile>
    </ContentBrick>
  );
};
